import { writable } from 'svelte/store';
import type { AssistantMessage } from '$lib/types/ai';

export const showAIChat = writable<boolean>(false);
export const aiChatActive = writable<boolean>(false);
// Whether AI mode view is active (classic mode underneath, AI UI overlaid)
export const aiModeActive = writable<boolean>(false);

// Persistent chat state that survives component mount/unmount
export const aiChatMessages = writable<AssistantMessage[]>([]);
export const aiChatFilters = writable<Record<string, unknown>>({});
export const aiChatRefinementQuery = writable<string>('');
